import React, {useEffect, useState} from 'react'
import './AddMoney.scss'
import cogoToast from "cogo-toast";
import AddMoneyToWalletMutation from "../../mutations/AddMoneyToWalletMutation";
import {AddOrderData} from "../../Actions";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {Zoom} from 'react-reveal'
import {assetUrl} from "../../serviceApi";

const bolt = assetUrl+'images/icon_wallet_bolt.svg'
const wrong_image = assetUrl+'images/wrong_image.svg'
const card_wallet = assetUrl+'images/card_wallet.svg'
const wallet_purse_image = assetUrl+'images/wallet_purse_image.svg'
const Star_image = assetUrl+'images/Star_image.svg'
const arrow_right = assetUrl+'images/arrow_right.svg'
const card_wallet_shadow = assetUrl+"images/wallet-card-shadow.svg";


const AddMoney = (props) => {
	const {setActiveModal, wallet_data,hideDefaultClose} = props;
	const [amount, setAmount] = useState(0);
	const [activePopularAmount, setActivePopularAmount] = useState(1000);
	const [popularAmounts] = useState(["100", "500", "1000", "5000"]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setAmount(activePopularAmount);
	}, [])

	const totalWalletBalance = () => {
		let deposit = parseInt(wallet_data.availableDeposit);
		let earnings = parseInt(wallet_data.availableEarnings);
		let grant = parseInt(wallet_data.availableGrantMoney);
		return (deposit + earnings + grant).toFixed(2);
	}
	const handleSubmit = () => {
		if (amount === "") {
			cogoToast.error("Please enter valid amount", {position: 'top-center'});
		}
		else if (amount < 1) {
			cogoToast.error("Entered amount is less than min amount Rs.1", {position: 'top-center'});
		} else {
			let input = {
				amount: parseInt(amount)
			}
			setLoading(true);
			AddMoneyToWalletMutation(input, function (response) {
				setLoading(false);
				if (response.updateWallet.payment !== null) {
					let obj = {
						order_total: amount
					}
					let formatedData = Object.assign(obj, response.updateWallet.payment);
					props.sendOrderDatasToStore(formatedData);
					setActiveModal("");
					props.history.push("/payment");
				}
			}, function (err) {
				setLoading(false);
				cogoToast.error(err, {position: 'top-center'});
			});
		}

	}
	return (
		<div className={'mx-2'}>

					<div className="wallet-cash-banner " style={hideDefaultClose?{display:"none"}:null}>
						<div className="wallet-cash-banner-wrong_text  " onClick={() => setActiveModal("")}>
							<img src={wrong_image} alt="Italian-Trulli" className="wallet-cash-banner-wrong_icon"/>
						</div>
					</div>

			<div className="wallet-cash-card ">
				<div className="text-center">
					<Zoom delay={500}><img src={card_wallet} alt="Italian-Trulli"
					                       className="wallet-cash-card-card_image"/></Zoom>
					<div className={'text-center mb-2'}>
						<Zoom delay={500}><img src={card_wallet_shadow} alt="Italian Trulli" className={"margin-auto"}/></Zoom>
					</div>
					<p className="wallet-cash-card-heading_text my-2">Add Money</p>
				</div>
			</div>
			<div className="wallet-cash-part ">
				<div className="wallet-cash-part-heading_part d-flex justify-content-between mb-3 ">
					<div>
						<p className="wallet-cash-part-wallet_text my-1">Wallet Amount</p>
						<p className="wallet-cash-part-wallet_number mb-0 ">
							₹ {
							Object.keys(wallet_data).length > 0 ?
								wallet_data.balance : 0
						}
							{/*<span*/}
							{/*className="wallet-cash-part-wallet_number_text">.05</span>*/}
						</p>
					</div>
					<img src={wallet_purse_image} alt="Italian Trulli"
					     className="wallet-cash-part-wallet_image"/>
				</div>
			</div>
			<div>
				<form>
					<label htmlFor="text" className="value_text">Enter Value</label><br/>
					<input type="number" className="number_text"
					       value={amount}
					       onChange={(e) => {
						       setAmount(e.target.value);
					       }}/>
				</form>
			</div>

			<div className="wallet-cash-values ">
				<div className="d-flex align-items-start mb-4">
					{
						popularAmounts.map((item, index) => {
							return (
								<div key={index}>

									<div
										className={`wallet-cash-values-number_value mx-2 ${activePopularAmount === item ? "active" : ""}`}
										onClick={() => {
											setActivePopularAmount(item);
											setAmount(prevState => (parseInt(prevState)+parseInt(item)).toString());
										}}
									>
										{/*{index === 1 &&*/}
										{/*<img src={bolt} className={"wallet-cash-values-number_value_bolt"}*/}
										{/*     alt={"alt"}/>}*/}
										<p className="my-1">+{item}</p>
									</div>
									{
										index === 2 &&
										<div className="d-flex align-items-center mt-2">
											<p className="wallet-cash-values-popular_text my-0">Most Popular</p>
											<img src={Star_image} alt="Italian Trulli" className="star_icon"/>
										</div>
									}

								</div>
							);
						})
					}
				</div>
			</div>
			<div className="wallet-cash-footer  ">
				<button className="wallet-cash-footer-button-class py-2"
				        onClick={handleSubmit}
				        disabled={loading}
				>
					Add Money
					<img alt={"alt"} src={arrow_right}
					     className="wallet-cash-footer-arrow_image mx-2"/>
				</button>

			</div>

		</div>
	)
}
const mapStateToProps = state => ({
    wallet_data: state.WalletReducer.wallet_data
});

const mapDispatchToProps = dispatch => ({
    sendOrderDatasToStore: order_data => dispatch(AddOrderData(order_data)),
});


export default compose(
    withRouter,
    connect(mapStateToProps,mapDispatchToProps)
)(AddMoney);

